export default {
   "光子国际艺术大赛人气奖评选通道正式开启！": "光子国际艺术大赛人气奖评选通道正式开启！",
   "即日起至11月10日，每位用户可为喜爱的参赛作品点赞（每个用户给每个作品限投1票）。": "即日起至11月10日，每位用户可为喜爱的参赛作品点赞（每个用户给每个作品限投1票）。",
   "截至2020年11月10日北京时间中午12:00，参赛作品点赞数累计最高者获得最佳人气奖。": "截至2020年11月10日北京时间中午12:00，参赛作品点赞数累计最高者获得最佳人气奖。",
   "人气最高": "人气最高",
   "最新加入": "最新加入",
   "人气": "人气",
   "投票": "投票",
   "已投票": "已投票",
   "报名须知": "报名须知",
   "查看作品详情": "查看作品详情",
   "查看在线互动DEMO": "查看在线互动DEMO",
   "暂无参赛作品": "暂无参赛作品",
   "光子国际艺术大赛人气奖投票截止！": "光子国际艺术大赛人气奖投票截止！",
   "人气值": "人气值",
   "投票已截止!": "投票已截止!",
   "入围作品公布": "入围作品公布",
   "企业账户认证": "企业账户认证",
   "您的账户尚未进行企业认证，认证审核通过后即可发布活动，是否要去认证？": "您的账户尚未进行企业认证，认证审核通过后即可发布活动，是否要去认证？",
   "立即认证": "立即认证",
   "最多视频": "最多视频",
   "最多成员": "最多成员",
   "创建学习频道": "创建学习频道",
   "创建高校频道": "创建高校频道",
   "播放反馈": "播放反馈",
   "反馈视频": "反馈视频",
   "问题描述": "问题描述",
   "发送反馈": "发送反馈",
   "播放卡顿": "播放卡顿",
   "进度条拖动失败": "进度条拖动失败",
   "播放时一直出现加载动画": "播放时一直出现加载动画",
   "黑屏": "黑屏",
   "其它": "其它",
   "点击查看": "点击查看",
   "年度盘点": "年度盘点",
   "2020MANA年度全球精选作品盘点": "2020MANA年度全球精选作品盘点",
   "2021MANA年度全球精选作品盘点": "2021MANA年度全球精选作品盘点",
   "预估作品落地成本": "预估作品落地成本",
   "5万以下": "5万以下",
   "5-10万": "5-10万",
   "10-30万": "10-30万",
   "30-50万": "30-50万",
   "50万以上": "50万以上",
   "请选择预估作品落地成本": "请选择预估作品落地成本",
   "该竞赛已结束！": "该竞赛已结束！",

   "上传手持证件照正面": "上传手持证件照正面",
   "请上传手持证件照正面": "请上传手持证件照正面",
   "字数限制50-500字": "字数限制50-500字",
   "指导老师": "指导老师",
   "选填，请输入指导老师姓名": "选填，请输入指导老师姓名",
   "指导老师手机号": "指导老师手机号",
   "选填，请输入指导老师手机号": "选填，请输入指导老师手机号",
   "在线互动demo URL地址": "在线互动demo URL地址",
   "如Realibox等": "如Realibox等",
   "选填，在线互动demo URL地址": "选填，在线互动demo URL地址",
   "上传附件": "上传附件",
   "可上传多个附件(压缩包、PDF等)，每个附件大小不超过100M": "可上传多个附件(压缩包、PDF等)，每个附件大小不超过100M",
   "上传": "上传",
   "文件不能大于100M": "文件不能大于100M",
   "文件不能大于10M": "文件不能大于10M",
   "时长为1-5分钟，分辨率不小于1920*1080": "时长为1-5分钟，分辨率不小于1920*1080",
   "50-500字": "50-500字",
   "身份": "身份",
   "当前学习阶段": "当前学习阶段",
   "专科": "专科",
   "本科": "本科",
   "研究生": "研究生",
   "学号": "学号",
   "请输入学号": "请输入学号",
   "通讯地址": "通讯地址",
   "请输入通讯地址": "请输入通讯地址",
   "请输入微信号": "请输入微信号",
   "如没有微信请输入无": "如没有微信请输入无",
   "注：以下信息仅用于竞赛实名认证，我们将严格保密": "注：以下信息仅用于竞赛实名认证，我们将严格保密",
   "真实姓名": "真实姓名",
   "请输入真实姓名": "请输入真实姓名",
   "身份证号码": "身份证号码",
   "请输入身份证号码": "请输入身份证号码",
   "认证信息": "认证信息",
   "上传手持身份证照": "上传手持身份证照",
   "上传身份证正面照片": "上传身份证正面照片",
   "上传身份证反面照片": "上传身份证反面照片",
   "（个人信息面）": "（个人信息面）",
   "（国徽面）": "（国徽面）",
   "请上传证件照正面": "请上传证件照正面",
   "请上传证件照反面": "请上传证件照反面",
   "最多添加10个": "最多添加10个",
   "请选择当前学习阶段": "请选择当前学习阶段",
   "你的认证信息已审核通过": "你的认证信息已审核通过",
   "认证信息审核中": "认证信息审核中",
   "实名认证": "实名认证",
   "注销账号": "注销账号",
   "MANA账号注销后不可恢复": "MANA账号注销后不可恢复",
   "你的私有数据将被": "你的私有数据将被",
   "永久删除": "永久删除",
   "建议做好备份": "建议做好备份",
   "继续注销": "继续注销",
   "返回个人中心": "返回个人中心",
   "说一下注销的原因吧": "说一下注销的原因吧",
   "注销成功": "注销成功",
   "后自动返回首页": "后自动返回首页",
   "其他原因（请填写）": "其他原因（请填写）",
   "填写理由示例": "填写理由示例",
   "请选择注销原因！": "请选择注销原因！",
   "入围公示": "入围公示",
   "选用公示": "选用公示",
   "请输入门票价格": "请输入门票价格",
   "请输入报名/购票链接": "请输入报名/购票链接",
   "请选择活动报名开始时间": "请选择活动报名开始时间",
   "请选择活动报名结束时间": "请选择活动报名结束时间",
   "请选择活动举办开始时间": "请选择活动举办开始时间",
   "请选择活动举办结束时间": "请选择活动举办结束时间",
   "链接应以http://或 https://开头": "链接应以http://或 https://开头",
   '您已成功提交参赛作品，该作品将会在作品征集截止（2022年9月30日）后同步至竞赛主办方官网“澜景· 未来媒体学院奖”（x）。': '您已成功提交参赛作品，该作品将会在作品征集截止（2022年9月30日）后同步至竞赛主办方官网“澜景· 未来媒体学院奖”（<a href="https://www.fmaa.cc/" style="color: #2026CC;" target="_blank">{count}</a>）。',
   '学院奖官网登录账号为您的注册邮箱，默认密码将在作品征集截止后发送至您的邮箱，请注意查收。感谢参与！': '学院奖官网登录账号为您的注册邮箱，默认密码将在作品征集截止后发送至您的邮箱，请注意查收。感谢参与！',
   '暂不支持GIF格式，请上传其它图片': '暂不支持GIF格式，请上传其它图片',
}



// WEBPACK FOOTER //
// ./src/languages/cn/works.js